import React from "react";
import { WidgetPage } from "app/layout/WidgetPage/WidgetPage";
import { clientConfig } from "app/config";
import { createStore } from "app/main/functions";
import { QuickSearchFieldContainer } from "app/search/QuickSearchFieldContainer/QuickSearchFieldContainer";
import { PageDataProvider } from "app/main/PageDataProvider";
import { Store } from "app/main/DataProvider";
import { GetServerSidePropsContext } from "next";
import { setSentryContext } from "app/sentry/ssr";

interface StreamWidgetProps {
    store: Store;
}

function WidgetPageRoot({ store }: StreamWidgetProps) {
    return (
        <WidgetPage>
            <PageDataProvider value={store}>
                <QuickSearchFieldContainer widgetMode />
            </PageDataProvider>
        </WidgetPage>
    );
}

export async function getServerSideProps(context: GetServerSidePropsContext) {
    setSentryContext(context);
    const store = createStore(null, "", clientConfig);
    return {
        props: {
            store
        }
    };
}

export default WidgetPageRoot;
